import { DossierOperation, DossierOperationFile, DossierOperationOption, SelectedDossierOperation } from 'app/modules/models/dossierOperation.type';

/** Compare calendar days so local midnight does not shift a validity boundary through UTC. */
function dateKey(date: Date): string {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
}

export function resolveOperationFile(operation: DossierOperation, date: Date, cdp: boolean): DossierOperationFile | null {
  if (!(date instanceof Date) || isNaN(date.getTime())) return null;
  const day = dateKey(date);
  const files = (operation.ceeOperationFiles || []).filter(file =>
    !!file.id && !!file.name && !!file.isCdp === cdp &&
    (!file.startDate || file.startDate.slice(0, 10) <= day) &&
    (!file.endDate || day <= file.endDate.slice(0, 10))
  );
  // Resolve the newest applicable version independently of catalogue order.
  return files.sort((a, b) => (b.startDate || '').localeCompare(a.startDate || '') || a.id.localeCompare(b.id))[0] || null;
}

export function operationOptions(operations: DossierOperation[], date: Date, cdp = false): DossierOperationOption[] {
  return operations.map(operation => {
    const file = cdp
      ? resolveOperationFile(operation, date, true)
      : resolveOperationFile(operation, date, false) || resolveOperationFile(operation, date, true);
    return file ? { operation, file, sector: file.activitySector?.name || 'Autres', label: `${file.name} : ${operation.label}` } : null;
  }).filter(option => !!option)
    .sort((a, b) => a.sector.localeCompare(b.sector, 'fr') || a.file.name.localeCompare(b.file.name, 'fr'));
}

export function selectOperation(operation: DossierOperation, file: DossierOperationFile, cdp: boolean): SelectedDossierOperation {
  return {
    genericOperationId: operation.id,
    genericOperationName: operation.label,
    ceeOperationFileId: file.id,
    ceeOperationFileName: file.name,
    cdp: cdp && !!file.isCdp,
  };
}
